import { CustomFieldType } from '@core/custom-fields-types';

import type { SalaryData } from './offers.types';

export enum RequisitionJobCompareFieldKey {
  Department = 'department',
  Priority = 'priority',
  RecruiterId = 'recruiter_id',
  HiringManagerId = 'hiring_manager_id',
  CountryName = 'country_name',
  StateName = 'state_name',
  City = 'city',
  Street = 'street',
  Remote = 'remote',
  EmploymentType = 'employment_type',
  Category = 'category',
  Education = 'education',
  Experience = 'experience',
  MinHoursPerWeek = 'min_hours_per_week',
  MaxHoursPerWeek = 'max_hours_per_week',
  Salary = 'salary',
  LocationIds = 'location_ids',
  WorkModel = 'work_model',
}

export interface CompareFieldsData {
  fields: CommonFieldCompareData[];
  customFields?: CustomFieldCompareData[];
}

export type CommonFieldCompareData = {
  field: RequisitionJobCompareFieldKey;
  isEqual: boolean;
  offer: string | string[] | number | number[] | boolean | SalaryData | null;
  requisition: string | string[] | number | number[] | boolean | SalaryData | null;
};

export type CustomFieldCompareData = {
  field: {
    id: number;
    name: string;
    type: CustomFieldType;
  };
  isEqual: boolean;
  offer: string | string[] | number | number[] | boolean | SalaryData | null;
  requisition: string | string[] | number | number[] | boolean | SalaryData | null;
};

export type OpeningAssignment = {
  openingId: number;
  placementId: number;
};
